<svelte:options accessors={true} />

<script>
    import Row from './Row.svelte'
    import InfoInput from './InfoInput.svelte'
    
    export let page = 'ios:l2tp:start'

    function textRandNext() {
        let variants = [
            'Получилось ☺️, далее',
            'Далее',
            'Что дальше? 🤔',
            'Продолжить'
        ]
        return variants[Math.floor((Math.random()*variants.length))]
    }

</script>
<style>
    ol {
        margin-left:5px;
        margin-right:5px;
    }
</style>
<!-- L2TP -->
<div style="margin-left:10px; margin-right:10px;">
{#if page == 'ios:start'}
    <Row info="" title="iPhone/iPad">
        Для подключения есть два варианта:
        <ol>
            <li>Без приложения - L2TP/IPSec, быстро настроить, но может быть заблокирован вашим оператором связи.</li>
            <li>Через приложение OpenVPN - надежнее, сложнее заблокировать</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='ios:ovpn:start'}}">OpenVPN</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='ios:l2tp:start'}}">Без приложения</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page === 'android:start'}
    <Row info="" title="Android">
        Для подключения есть два варианта:
        <ol>
            <li>Через приложение OpenVPN - надежнее, сложнее заблокировать, работает на Android 12</li>
            <li>Без приложения - L2TP/IPSec, быстро настроить, но может быть заблокирован вашим оператором связи, может не работать на Android 12</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='android:ovpn:start'}}">OpenVPN</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='android:l2tp:start'}}">Без приложения</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page === 'ios:l2tp:start'}
    <Row info="" title="Настройка L2TP VPN на Apple iPhone или iPad">
        <ol>
            <li>
                Открываем "Настройки"
            </li>
            <li>
                Переходим в "Основное" 👉 "VPN и управление устройством" 👉 "VPN"
            </li>
            <li>
                Нажимаем "Добавить концигурацию VPN ..."
                <br/><img src="/images/ios05.jpg" alt="VPN" />
            </li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='ios:l2tp:profile_set'}}">{textRandNext()}</button>
        <a role="button" class="btn btn-primary mr-2 mb-2" href="https://t.me/vpnmshv/6" target="_blank" style="display:inline-block;">Видео-инструкция 📹</a>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page == 'ios:l2tp:profile_set'}
    <Row info="" title="Добавление профиля">
        <ol start="4">
            <li>Заполняем профиль вот так:<br/><br/>
                <InfoInput title="Тип" value="L2TP" copyAllow={false} />
                <InfoInput title="Описание" value="v.mshv.me" />
                <InfoInput title="Сервер" value="v.mshv.me" />
                <InfoInput title="Учетная запись" value={app.account.login} />
                <InfoInput title="Пароль" value={app.account.password} />  
                <InfoInput title="Общий ключ" value="ALASKA" />
            </li>
            <li>Нажимаем "Готово" (справа, вверху)</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='ios:l2tp:conncet'}}">{textRandNext()}</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='ios:l2tp:start'}}">Назад</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page == 'ios:l2tp:conncet'}
    <Row info="" title="Всё готово!">
        <ol start="6">
            <li>В меню "Статус" переключаем флажок, это запустит процесс подключения к VPN</li>
            <li>
                После добавления профиля VPN в "Настройках" появится пункт "VPN" и тебе не прийдется каждый раз открывать "Основное" и т/д ... Используй его для быстрого подключения к VPN.
                <br/><img src="/images/ios06.jpg" alt="VPN" />
            </li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='ios:l2tp:profile_set'}}">Назад</button>
    </Row>
{:else if page == 'android:l2tp:start'}
    <Row info="" title="Настройка L2TP VPN на Android">
        <ol>
            <li>Открываем "Настройки"</li>
            <li>В поиске вводим: "VPN"</li>
            <li>Выбираем пункт, там где "Подключение и общий доступ"</li>
            <li>Нажимаем на плюс ➕ (справа, вверху)</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='android:l2tp:profile_set'}}">{textRandNext()}</button>
        <a role="button" class="btn btn-primary mr-2 mb-2" href="https://t.me/vpnmshv/9" target="_blank" style="display:inline-block;">Видео-инструкция 📹</a>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page == 'android:l2tp:profile_set'}
    <Row info="" title="Добавление профиля">
        <ol start="5">
            <li>Заполняем профиль вот так:<br/><br/>
                <InfoInput title="Название сети" value="v.mshv.me" />
                <InfoInput title="Тип" value="L2TP/IPSec PSK" copyAllow={false} />
                <InfoInput title="Адрес сервера" value="v.mshv.me" />
                <InfoInput title="Общий ключ IPSec" value="ALASKA" />
            </li>
            <li>Остальные поля оставляем без изменений</li>
            <li>Нажимаем ✅ (справа, вверху)</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='android:l2tp:conncet'}}">{textRandNext()}</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='android:l2tp:start'}}">Назад</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page == 'android:l2tp:conncet'}
    <Row info="" title="Почти готово!">
        <ol start="8">
            <li>Нажимаем на появившийся VPN: "v.mshv.me"</li>
            <li>Вводим данные авторизации:<br/><br/>
                <InfoInput title="Имя пользователя" value={app.account.login} />
                <InfoInput title="Введите пароль" value={app.account.password} /> 
            </li>
            <li>Нажимаем "Подключиться" - всё готово 🤗</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='android:l2tp:profile_set'}}">Назад</button>
    </Row>
{:else if page == 'ios:ovpn:start'}
    <Row info="" title="Установите OpenVPN">
        <ol>
            <li>
                Устанавливаем приложение 
                👉 <b><a target="_blank" href="https://apps.apple.com/ru/app/openvpn-connect/id590379981">OpenVPN Connect</a></b> 👈
                <br/><img src="/images/iosinstall.jpg" />
            </li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='ios:ovpn:config'}}">{textRandNext()}</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page == 'ios:ovpn:config'}
    <Row info="" title="Настройка OpenVPN VPN на Apple iPhone или iPad">
        <ol>
            <li>
                Загружаем профиль по кнопке ниже и открываем его с помощью OpenVPN Connect
                <a role="button" class="btn btn-primary mb-2 mt-2" href="/config.ovpn" style="display:block;max-width:300px;margin:auto;">config.ovpn</a>
            </li>
            <li>
                В "Import Profiles" нажимаем "Add" напротив появившегося профиля "v.mshv.me"
                <!-- <br/><img src="/images/ios05.jpg" alt="VPN" /> -->
            </li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='ios:ovpn:profile_set'}}">{textRandNext()}</button>
        <a role="button" class="btn btn-primary mr-2 mb-2" href="https://t.me/vpnmshv/16" target="_blank" style="display:inline-block;">Видео-инструкция 📹</a>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='ios:ovpn:start'}}">Назад</button>
    </Row>
{:else if page == 'android:ovpn:start'}
    <Row info="" title="Настройка OpenVPN VPN на Android">
        <ol>
            <li>
                Устанавливаем приложение <a target="_blank" href="https://play.google.com/store/apps/details?id=net.openvpn.openvpn&hl=en&gl=US">OpenVPN Connect</a>
            </li>
            <li>
                Загружаем профиль по кнопке ниже и открываем его с помощью OpenVPN Connect
                <a role="button" class="btn btn-primary mb-2" href="/config.ovpn" style="display:block;max-width:300px;margin:auto;">config.ovpn</a>
            </li>
            <li>
                В "Import Profiles" нажимаем "Add" напротив появившегося профиля "v.mshv.me"
                <!-- <br/><img src="/images/ios05.jpg" alt="VPN" /> -->
            </li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='android:ovpn:profile_set'}}">{textRandNext()}</button>
        <a role="button" class="btn btn-primary mr-2 mb-2" href="https://t.me/vpnmshv/18" target="_blank" style="display:inline-block;">Видео-инструкция 📹</a>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
        <br/>
        <!-- <video src="/images/iosovpn1.mp4" width="640" height="360" autoplay playsinline></video> -->
    </Row>
{:else if page == 'ios:ovpn:profile_set'}
    <Row info="" title="Заполнение профиля">
        <ol start="4">
            <li>Заполняем профиль вот так:<br/><br/>
                <InfoInput title="Username" value={app.account.login} />
                <InfoInput title="Save password" value="☑️ (поставить галочку)" />
                <InfoInput title="Password" value={app.account.password} /> 
            </li>
            <li>Остальные поля оставляем без изменений</li>
            <li>Нажимаем "Connect" (справа, внизу)</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='ios:ovpn:connect'}}">{textRandNext()}</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='ios:ovpn:config'}}">Назад</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page == 'android:ovpn:profile_set'}
    <Row info="" title="Заполнение профиля">
        <ol start="4">
            <li>Заполняем профиль вот так:<br/><br/>
                <InfoInput title="Username" value={app.account.login} />
                <InfoInput title="Save password" value="☑️ (поставить галочку)" />
                <InfoInput title="Пароль" value={app.account.password} /> 
            </li>
            <li>Остальные поля оставляем без изменений</li>
            <li>Нажимаем "Connect" (справа, внизу)</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{page='android:ovpn:connect'}}">{textRandNext()}</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='android:ovpn:start'}}">Назад</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    </Row>
{:else if page == 'ios:ovpn:connect'}
    <Row info="" title="Всё готово!">
        <ol start="5">
            <li>Подключаться к VPN можно либо из приложения OpenVPN, либо из системного меню "Настройки"</li>
        </ol>
        <button class="btn btn-success mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
        <button class="btn btn-secondary mr-2" on:click="{()=>{page='ios:ovpn:profile_set'}}">Назад</button>
    </Row>
{:else if page == 'android:ovpn:connect'}
<Row info="" title="Всё готово!">
    <ol start="6">
        <li>Подключаться к VPN можно либо из приложения OpenVPN, либо из системного меню "Настройки"</li>
    </ol>
    <button class="btn btn-success mr-2" on:click="{()=>{app.pageChange('info')}}">Закрыть</button>
    <button class="btn btn-secondary mr-2" on:click="{()=>{page='android:ovpn:profile_set'}}">Назад</button>
</Row>
{/if}
</div>
<!--

 
-->